import { Component, EventEmitter, Input, OnInit, Output, ElementRef, HostListener } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit {
  @Input() btnOption: any;
  @Output() clickEvent = new EventEmitter<boolean>();

  @Input() disabled = false;

  @Input() loading = false;


  constructor(private elRef: ElementRef) {}
  ngOnInit(): void {}

  emitEvent(): void {
    this.clickEvent.emit(true);
  }

    @HostListener('keyup.enter', ['$event'])
    onEnterPress(event: KeyboardEvent): void {
        event.preventDefault();

        const button = this.elRef.nativeElement.querySelector('button label');
        if (button) {
            button.click();
        }
    }
}
